import { Component, ElementRef, ViewChild} from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { FormGroup, FormControl, Validators , FormBuilder} from '@angular/forms';
import { Router } from '@angular/router';
import { CommonEventService } from '../services/common-event.service';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { LocationStrategy } from '@angular/common';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent {
  
  title = 'appBootstrap';
  tax_options = [{ name: 'Taxable' }, { name: 'Non-taxable' } ];
  sel_tax_option:string = "Taxable";
  closeResult: string = '';
  showCityInputText :boolean = false;
  selectedShippingAddressId = "no_id";
  selectedBillingAddressId = "no_id";
  selectedDesignerAddressId = "no_id";
  markAsDefault = false;
  addressDeleted: boolean = false;
  taxShowing: any = {};
  cardType:any;
  expiryYear: any = [];
  cardExpiryYear: any;
  cardExpiryMonth: any;
  paymentSubmitForm : boolean = false;
  isChangeBtnDisable:boolean=false;
  editSelectedAdId:any;
  promoCodeText:string = "";
  summaryPromoShow : boolean = false;
  expanded : boolean = false;
  addressDomain: string = '';
  unauthDomain: string = '';
  addressEmailisValid: boolean = false;
  unauthEmailisValid: boolean = false;
  flowActivityId:any='';
 // paymentForm: FormGroup;
  
  expiryMonths = [
    {name: 'January',value: '01'},
    {name: 'February',value: '02'},
    {name: 'March',value: '03'},
    {name: 'April',value: '04'},
    {name: 'May',value: '05'},
    {name: 'June',value: '06'},
    {name: 'July',value: '07'},
    {name: 'August',value: '08'},
    {name: 'September',value: '09'},
    {name: 'October',value: '10'},
    {name: 'November',value: '11'},
    {name: 'December',value: '12'},
  ]

  @ViewChild("cardName") cardName!: ElementRef;
  @ViewChild("cardNum") cardNum!: ElementRef;
  @ViewChild("cardCvv") cardCvv!: ElementRef;
  @ViewChild("resaleSection") resaleSec!: ElementRef;
  @ViewChild("shippingAccountNum") shippingAccNum!: ElementRef;
  @ViewChild("notAuthFirstName") authFistName!: ElementRef;
  //@ViewChild("notAuthLastName") authLastName!: ElementRef;
  @ViewChild("notAuthEmail") authEmail!: ElementRef;
  @ViewChild("notAuthAgreed") authAgreed!: ElementRef;
  

  constructor(private modalService: NgbModal,public apiService:ApiService,public commonService : CommonEventService,private router: Router,public formBuilder : FormBuilder,private location: LocationStrategy) {
    // if(localStorage.getItem('apiSerDataObj') && localStorage.getItem('commonDataObj') && this.commonService.commonMainObj.onlyPcb == true){
    //   let apiObj:any = localStorage.getItem('apiSerDataObj')
    //   let commonObj:any = localStorage.getItem('commonDataObj')
    //   this.apiService.apiMainObj = JSON.parse(apiObj) 
    //   this.commonService.commonMainObj = JSON.parse(commonObj)
    //   this.commonService.commonMainObj.isGuestUser = false;
    // }
    this.taxShowing.shipAddress = false;
    this.apiService.apiMainObj.selectedShippingAddress = {};
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.restrictBrowserButtons();
    this.commonService.restrictRefreshButton();
    this.commonService.formattingCurrentDateTime();
    if(localStorage.getItem('apDtId')){
      this.apiService.getAppStoreData(localStorage.getItem('apDtId')).subscribe((storeAppDataObj) =>{
        let strAppDt = JSON.parse(storeAppDataObj.fileData)
        this.apiService.apiMainObj = JSON.parse(strAppDt.data['apiSerDataObj'])
        this.commonService.commonMainObj = JSON.parse(strAppDt.data['commonDataObj'])
        this.guestUserStoreDataGet();
      })
    }else{
      this.guestUserStoreDataGet()
    }
  }

  guestUserStoreDataGet(){
    this.commonService.commonMainObj.openCheck = false;
    if(localStorage.getItem('apDtId') && localStorage.getItem('apDtId') != '' && this.commonService.commonMainObj.onlyPcb == true){
      this.commonService.commonMainObj.isGuestUser = false;
      setTimeout(()=>{
        this.apiService.apiMainObj.encUrlData = localStorage.getItem('encData')
        this.userSessionCheck();
      },700);
    }else{
      this.commonService.loadingShow();
      this.initFn();
    }
    setTimeout(() => {
      this.notAuthSelection('');
    }, 500);
    setTimeout(()=>{
      this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    },700);
  }

  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }
  
  
  restrictBrowserButtons(){
    this.commonService.commonMainObj.openCheck = false;
    history.pushState({}, '', window.location.href);
    this.location.onPopState(() => {
      history.pushState({}, '', window.location.href);
      if(!this.commonService.commonMainObj.openCheck){
        this.restrictBrowserButtonsAlert();
      }
    });
  }
  restrictBrowserButtonsAlert(){
    this.commonService.commonMainObj.openCheck = true;
    Swal.fire({
      title: 'Alert!',
      text:"Navigating back will result in the loss of data",
      showConfirmButton: true,
      showDenyButton: false,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.commonService.goBack();
      } else if (result.isDismissed) {
        this.commonService.commonMainObj.openCheck = false;
      }
    })
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event:any) {
    event.preventDefault();
    this.restrictBrowserButtons();
  }

  userSessionCheck(){
    this.commonService.loadingShow();
    let sessionData = localStorage.getItem('encData')
    this.apiService.getUserDataSession(sessionData).subscribe((resData: any)=>{
      this.commonService.loadingHide();
      this.commonService.commonMainObj.userSessionMemberId = resData.memberId;
      if(localStorage.getItem('apDtId') && localStorage.getItem('apDtId') != ''){
        if(resData && resData.status == "NO_SESSION"){
          this.commonService.commonMainObj.userData = {};
          this.commonService.commonMainObj.sessionCheck = false;
          this.commonService.commonMainObj.isGuestUser = true;
        }else if(resData && resData.status == 'SESSION_FOUND'){
          if(this.commonService.commonMainObj.email && resData.registrationEmail != this.commonService.commonMainObj.email){
            this.commonService.commonMainObj.invalidUser = true;
            this.commonService.commonMainObj.loginEmail = resData.registrationEmail
            this.commonService.commonMainObj.boardDetailsDataObj.email = resData.registrationEmail;
          }
          this.commonService.commonMainObj.userId = resData.userId
          this.commonService.commonMainObj.userData = resData;
          this.commonService.commonMainObj.sessionCheck  = true;
          this.commonService.commonMainObj.isGuestUser = false;
        }
      }
      this.initFn();
      if(this.commonService.commonMainObj.tryToSigninOrRegister){
        // setTimeout(() => {
        //   let signInMsgObj={
        //     "signIn": this.commonService.commonMainObj.invalidUser ? "Sign-in failed": this.commonService.commonMainObj.newUser? 'Registration successful':'Sign-in successful'
        //   };
      
        //   this.apiService.updateDetailsToDashboard(this.flowActivityId,signInMsgObj,'SignInRegistrationPage').subscribe((resDatas)=>{
        //   },err=>{
        //     console.log(err)
        //   });
        // }, 1000);
      }
    },err=>{
      if(err.status == 200){
        if(err.error.text == "NO_SESSION"){
          this.commonService.commonMainObj.sessionCheck = false;
        }else{
          this.commonService.commonMainObj.userData = {};
        }
      }else{
        
      }
      console.log(err)
    });
    
  }

  initFn(){
    if(this.commonService.commonMainObj.invalidUser){
      return false;
    }
    this.apiService.getTaxData().subscribe(data =>{
      let taxData = new Array();
      for(let i = 0; i < data.length; i++){
        taxData.push({
          rate    : data[i].rate,
          city    : data[i].city,
          country : data[i].country
        })
      }
      //After getting data from tax API next will get address and all
      this.commonService.commonMainObj.taxInformation = taxData;
      this.apiService.getAllAddress('list').then((res: any)=>{
        // this.commonService.loadingHide();
        if(this.apiService.apiMainObj.alladdress.length==0){
          this.isChangeBtnDisable = true;
        }else{
          this.isChangeBtnDisable = false;
        }
        for(let addresses in res){
          if (res[addresses]['isDefaultForShipping']=='1') {
            this.taxShowing.shipAddress = true;
          }
        }
        if (res.length == 0) {
          this.apiService.apiMainObj.selectedBillingAddress = {};
          this.apiService.apiMainObj.selectedShippingAddress = {};
          this.apiService.apiMainObj.selectedDesignerAddress = {};
        }
        if(this.commonService.commonMainObj.backToOrderDetails){
          this.commonService.commonMainObj.taxable = this.commonService.commonMainObj.taxableBeforeOrderReview?true:false;
        }
        this.checkTaxResale();
        if(this.apiService.apiMainObj.selectedShippingAddress && Object.keys(this.apiService.apiMainObj.selectedShippingAddress).length >0){
          this.shippingMethod('default');
        }else{
          this.commonService.loadingHide();
        }
      });
    },error =>{
      this.commonService.loadingHide();
      console.log('error found while get tax data', error);
    });

    this.apiService.getResaleInfoData().subscribe(data =>{
      if(data){
        // this.commonService.loadingHide();
        this.commonService.commonMainObj.resaleNumberDataFromAPi = data.userOrderDetails.resaleNumber;
      }
    }, error => {
      this.commonService.loadingHide();
      console.log("Error in getting Resal Info",error);
    });
    
    this.apiService.orderSummary();

    // if (!this.apiService.addressEditPopup){
      // this.apiService.apiMainObj.contact_country = this.apiService.defaultCountry;
      // console.log("this.apiService.defaultCountry",this.apiService.defaultCountry);
      // this.apiService.apiMainObj.contact_state = this.apiService.defaultState;
      // this.apiService.apiMainObj.contact_city = this.apiService.defaultCity;
    // }
    this.commonService.commonMainObj.selectedCardExpiryYear = new Date().getFullYear();
    // this.commonService.commonMainObj.selectedCardExpiryYear = this.cardExpiryYear;
    for(let n = 0; n< 20; n++){
      this.expiryYear.push({"name": (parseInt(this.commonService.commonMainObj.selectedCardExpiryYear)+n)+''});
    }
    
    this.taxShowing.visible = false;
    if(this.commonService.commonMainObj.backToOrderDetails){
      if(this.commonService.commonMainObj.cardExpiryDate){
        this.commonService.commonMainObj.selectedCardExpiryMonth = this.commonService.commonMainObj.cardExpiryDate.split('/')[0];
        this.commonService.commonMainObj.selectedCardExpiryYear = this.commonService.commonMainObj.cardExpiryDate.split('/')[1];
      }
      if(this.commonService.commonMainObj.promoCode){
        this.promoCodeText = this.commonService.commonMainObj.promoCode;
        setTimeout(()=>{
          $('#promo_code_apply').prop('disabled', true);
          $('#promo_code').prop('disabled',true);
        },500);
        this.summaryPromoShow = true;
      }
    }else{
      setTimeout(()=>{
        this.yearChanged(this.expiryYear[0].name)
        this.commonService.commonMainObj.selectedCardExpiryMonth = new Date().getMonth()<9?"0"+(new Date().getMonth() + 1)+'':(new Date().getMonth() + 1)+'';
        // this.commonService.commonMainObj.selectedCardExpiryMonth = this.cardExpiryMonth;
      },500)
    }

    // setTimeout(() => {
    //   // if(!this.commonService.commonMainObj.invalidUser){
    //     let orderDetailsData={
    //       "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    //     }
    //     this.apiService.updateDetailsToDashboard(this.flowActivityId,orderDetailsData,'OrderDetailsPage').subscribe((resDatas)=>{
    //     },err=>{
    //     console.log(err)
    //     });
    //   // }
    // }, 1000);
  }

  createAddressForm = new FormGroup({
    //selectAddressType: new FormControl('', []),
    shippingType: new FormControl('', []),
    billingType: new FormControl('', []),
    designerType: new FormControl('', []),
    companyName: new FormControl('', [Validators.required, Validators.minLength(1),Validators.maxLength(100)]),
    firstName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    lastName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    addressEmail: new FormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.pattern(/^(?!\.)(?!.*\.\.)[a-zA-Z0-9_.-]{1,64}(?<!\.)@(?!(?:.*-[0-9]+\.){2,})(?=[a-zA-Z0-9-]{1,61}\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,63}$/)]),
    addressOne: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(225)]),
    addressTwo: new FormControl('', [Validators.minLength(0), Validators.maxLength(225)]),
    adCountry: new FormControl('', [Validators.required]),
    adState: new FormControl('', [ Validators.minLength(2),Validators.maxLength(225)]),
    stateSelect: new FormControl('',[]),
    adCity: new FormControl('', [ Validators.minLength(2),Validators.maxLength(225)]),
    citySelect: new FormControl('',[]),
    adZip: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(6),Validators.pattern('[a-zA-Z0-9]*')]),
    adPhone: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10),Validators.pattern(/^\d*$/)]),
  });

  paymentForm = new FormGroup({
    // cardType:['', Validators.required],
    nameOnCard:new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(99), Validators.pattern('^[a-zA-Z ]*$')]),
    cardNumber:new FormControl('', [Validators.required, Validators.minLength(14), Validators.maxLength(16), Validators.pattern('^[0-9]+$')]),
    expMonth:new FormControl([new Date().getMonth()<10?"0"+(new Date().getMonth() + 1):(new Date().getMonth() + 1), Validators.required]),
    expYear:new FormControl('', []),
    cvv:new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(4), Validators.pattern('^[0-9]+$')])
  });

  unAuthorizedForm = new FormGroup({
    // cardType:['', Validators.required],
    unAuthFirstName:new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(99), Validators.pattern('^[a-zA-Z ]*$')]),
    unAuthLasttName:new FormControl('', [Validators.minLength(3), Validators.maxLength(99), Validators.pattern('^[a-zA-Z ]*$')]),
    unAuthEmail:new FormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.pattern(/^(?!\.)(?!.*\.\.)[a-zA-Z0-9_.-]{1,64}(?<!\.)@(?!(?:.*-[0-9]+\.){2,})(?=[a-zA-Z0-9-]{1,61}\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,63}$/)]),
    unAuthRemark:new FormControl('', [Validators.minLength(0), Validators.maxLength(1000)]),
    unAuthAgree: new FormControl('', [Validators.required]),
  });
  validateAddressDomain(): void {
    this.addressDomain = this.apiService.apiMainObj.contact_email;
    this.commonService.validateDomain(this.addressDomain);
    setTimeout(() => {
      this.addressEmailisValid = this.commonService.commonMainObj.invalidEmail;
    }, 100);
  }
  validateUnauthDomain(email:any): void {
    this.unauthDomain = this.commonService.commonMainObj.purchasingPersonDetails.email;
    this.commonService.validateDomain(email);
    setTimeout(() => {
      this.unauthEmailisValid = this.commonService.commonMainObj.invalidEmail;
    }, 100);
  }

  address_validation_messages = {
    'selectAddressType': [
      { type: 'required', message: '' },
      { type: 'minlength', message: '' },
      { type: 'maxlength', message: '' },
      { type: 'pattern', message: '' }
    ],
    'companyName': [
      { type: 'required', message: 'company name is required.' },
      { type: 'minlength', message: 'company name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'company name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your company name must contain only letters.' }
    ],
    'firstName': [
      { type: 'required', message: 'first name is required.' },
      { type: 'minlength', message: 'first name must be at least 1 characters long.' },
      { type: 'maxlength', message: 'first name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your first name must contain only letters.' }
    ],
    'lastName': [
      { type: 'required', message: 'last name is required.' },
      { type: 'minlength', message: 'last name must be at least 1 characters long.' },
      { type: 'maxlength', message: 'last name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your last name must contain only letters.' }
    ],
    'addressEmail': [
      { type: 'required', message: 'email is required.' },
      { type: 'minlength', message: 'email must be at least 4 characters long.' },
      { type: 'maxlength', message: 'email cannot be more than 25 characters long.' },
      { type: 'pattern', message: 'Please enter a valid email.' }
    ],
    'addressOne': [
      { type: 'required', message: 'Address1 is required.' },
      { type: 'minlength', message: 'Address1 must be at least 5 characters long.' },
      { type: 'maxlength', message: 'Address1 cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your Address1 must contain only letters.' }
    ],
    'addressTwo': [
      { type: 'required', message: 'Address2 is required.' },
      { type: 'minlength', message: 'Address2 must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Address2 cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your Address2 must contain only letters.' }
    ],
    'adCountry': [
      { type: 'required', message: 'Country is required.' },
      { type: 'minlength', message: 'Country must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Country cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your Country must contain only letters.' }
    ],
    'adState': [
      { type: 'required', message: 'State is required.' },
      { type: 'minlength', message: 'State must be at least 1 characters long.' },
      { type: 'maxlength', message: 'State cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your State must contain only letters.' }
    ],
    'adCity': [
      { type: 'required', message: 'City is required.' },
      { type: 'minlength', message: 'City must be at least 1 characters long.' },
      { type: 'maxlength', message: 'City cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your City must contain only letters.' }
    ],
    'adZip': [
      { type: 'required', message: 'Zipcode is required.' },
      { type: 'minlength', message: 'Zipcode must be at least 5 characters long.' },
      { type: 'maxlength', message: 'Zipcode cannot be more than 6 characters long.' },
      { type: 'pattern', message: 'Please enter valid Zipcode.' }
    ],
    'adPhone': [
      { type: 'required', message: 'Phone number is required.' },
      { type: 'minlength', message: 'Phone number must be at least 10 numeric long.' },
      { type: 'maxlength', message: 'Phone number cannot be more than 10 numeric long.' },
      { type: 'pattern', message: 'Special characters are not allowed in phone number' }
    ]
  }

  payment_validation_messages = {
    'nameOnCard': [
      { type: 'required', message: 'Name is required.' },
      { type: 'minlength', message: 'Name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Name must contain only letters.' }
    ],
    'cardNumber': [
      { type: 'required', message: 'Card number is required.' },
      { type: 'minlength', message: '' },
      { type: 'maxlength', message: '' },
      { type: 'pattern', message: 'Card number must contain only letters.' }
    ],
    'expMonth': [
      { type: 'required', message: 'Expire month is required.' },
    ],
    'expYear': [
      { type: 'required', message: 'Expire year is required.' },
    ],
    'cvv': [
      { type: 'required', message: 'CVV is required.' },
      // { type: 'minlength', message: 'Name must be at least 3 characters long.' },
      // { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'CVV must contain only letters.' }
    ]
  }
  not_auth_validation_messages = {
    'unAuthFirstName': [
      { type: 'required', message: 'Name is required.' },
      { type: 'minlength', message: 'Name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Name must contain only letters.' }
    ],
    'unAuthLasttName': [
      { type: 'required', message: '' },
      //{ type: 'minlength', message: 'Name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'Name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Name must contain only letters.' }
    ],
    'unAuthEmail': [
      { type: 'required', message: 'email is required.' },
      { type: 'minlength', message: 'email must be at least 4 characters long.' },
      { type: 'maxlength', message: 'email cannot be more than 25 characters long.' },
      { type: 'pattern', message: 'Please enter a valid email.' }
    ],
    'unAuthRemark': [
      // { type: 'required', message: 'Please fill Remarks' },
    ],
    'unAuthAgree': [
      { type: 'required', message: 'Please agree.' },
    ],
  }
  
  to_Num(x:any){
    return( parseInt(x,10) );
  }
  to_Float(x:any){
    if ( x!=null && x!="" && x!=undefined)
    return( parseFloat(x) );
    else
    return( parseFloat("0.00") );
  }
  countryClick(eve:any){
    this.apiService.apiMainObj.contact_state="";
    this.apiService.apiMainObj.contact_city="";
    if(this.apiService.apiMainObj.contact_country != "United States"){
      this.showCityInputText = true;
      // this.createAddressForm.addControl('adState', new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(255)]));
      // this.createAddressForm.addControl('adCity', new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(255)]));
      this.createAddressForm.controls["adState"].setValidators([Validators.required,Validators.minLength(2)]);
      this.createAddressForm.controls["adCity"].setValidators([Validators.required,Validators.minLength(2)]);
      this.createAddressForm.controls["adState"].updateValueAndValidity();
      this.createAddressForm.controls["adCity"].updateValueAndValidity();
      $("#input_state").show();
      //$("#input_city").show();
      $("#select_state").hide();
      //$("#select_city").hide();
    }else{
      this.apiService.apiMainObj.contact_state="California";
      this.apiService.apiMainObj.contact_city = "Sunnyvale";
      $("#input_state").hide();
      //$("#input_city").hide();
      $("#select_state").show();
      //$("#select_city").show();
      this.showCityInputText = false;
      this.createAddressForm.controls["adState"].setValidators([Validators.minLength(2)]);
      this.createAddressForm.controls["adCity"].setValidators([Validators.minLength(2)]);
      this.createAddressForm.controls["adState"].updateValueAndValidity();
      this.createAddressForm.controls["adCity"].updateValueAndValidity();
    }
  }
  stateClick(eve:any){
  if(this.apiService.apiMainObj.contact_country == "United States" && (this.apiService.apiMainObj.contact_state == "California" || this.apiService.apiMainObj.contact_state == "CA")){
    this.apiService.apiMainObj.contact_city = "Sunnyvale";
    this.showCityInputText = false;
    // $("#input_city").hide();
    // $("#select_city").show();
    this.createAddressForm.controls["adCity"].setValidators([Validators.minLength(2)]);
    this.createAddressForm.controls["adCity"].updateValueAndValidity();
  }else{
    this.showCityInputText = true;
    this.apiService.apiMainObj.contact_city = null;
    //$("#input_city").show();
    //this.createAddressForm.addControl('adCity', new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(255)]));
    this.createAddressForm.controls["adCity"].setValidators([Validators.required,Validators.minLength(2)]);
    this.createAddressForm.controls["adCity"].updateValueAndValidity();
    //$("#select_city").hide();
  }
  }
  //Address Book open logic
  openAddressBookLogic(content:any, addresstype:any) {
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{ 
          if(data.status == 1){
            this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
              this.closeResult = `Closed with: ${result}`;
            }, (reason) => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            });
          }
        },error =>{
          console.log('Error in checking user session', error);   
        })
      },1000);
  }

  //Address Book open
  openAddressBook(content:any, addresstype:any){
    this.commonService.loadingShow();
    this.commonService.sessionPortalLoad();
    if (addresstype == 'shipping'){
      this.apiService.apiMainObj.shippingAddressPopup = true;
      this.apiService.apiMainObj.addressBookName = "Shipping address book"
      this.apiService.apiMainObj.billingAddressPopup = false;
      this.apiService.apiMainObj.designerAddressPopup = false;
    }else if(addresstype == 'billing'){
      this.apiService.apiMainObj.shippingAddressPopup = false;
      this.apiService.apiMainObj.addressBookName = "Billing address book"
      this.apiService.apiMainObj.billingAddressPopup = true;
      this.apiService.apiMainObj.designerAddressPopup = false;
    }else{
      this.apiService.apiMainObj.shippingAddressPopup = false;
      this.apiService.apiMainObj.addressBookName = "Designer address book"
      this.apiService.apiMainObj.billingAddressPopup = false;
      this.apiService.apiMainObj.designerAddressPopup = true;
    }

    this.apiService.getAllAddress('book').then((res: any)=>{
      this.openAddressBookLogic(content,addresstype);
      this.commonService.loadingHide();
      // setTimeout(()=>{
        if(this.apiService.apiMainObj.alladdress.length>0){
          if(this.apiService.apiMainObj.alladdress.length==0){
            this.isChangeBtnDisable = true;
          }else{
            this.isChangeBtnDisable = false;
          }
          for(let adl in this.apiService.apiMainObj.alladdress){
            this.apiService.apiMainObj.alladdress[adl]['isCheckedDeliver'] = null;
            if (this.apiService.apiMainObj.shippingAddressPopup) {
              if (this.apiService.apiMainObj.alladdress[adl].isDefaultForShipping == '1' || this.apiService.apiMainObj.alladdress[adl].isDefaultForShipping == 1) { 
                this.apiService.apiMainObj.alladdress[adl]['isCheckedDeliver'] = true;
                this.deliverToAddress(this.apiService.apiMainObj.alladdress[adl],adl,'');
              }
            }
            if (this.apiService.apiMainObj.designerAddressPopup) {
              if (this.apiService.apiMainObj.alladdress[adl].isDefaultForDesign == '1' || this.apiService.apiMainObj.alladdress[adl].isDefaultForDesign == 1) { 
                this.apiService.apiMainObj.alladdress[adl]['isCheckedDeliver'] = true;
                this.deliverToAddress(this.apiService.apiMainObj.alladdress[adl],adl,'')
              }
            }
            if (this.apiService.apiMainObj.billingAddressPopup) {
              if (this.apiService.apiMainObj.alladdress[adl].isDefaultForBilling == '1' || this.apiService.apiMainObj.alladdress[adl].isDefaultForBilling == 1) { 
                this.apiService.apiMainObj.alladdress[adl]['isCheckedDeliver'] = true;
                this.deliverToAddress(this.apiService.apiMainObj.alladdress[adl],adl,'')
              }
            }
          }
        }
      // },500)
    });
  }

  //Delete address confirmation
  confirmDeleteAddress(addressData:any, addressTypeId:any){
    //this.apiService.apiMainObj.address_type_id =  addressTypeId;
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
      Swal.fire({
        title: 'Are you sure want to delete the card?',
        //icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: "Cancel"
      }).then((result) => {
        if (result['isConfirmed']){
          this.commonService.sessionPortalLoad();
          this.commonService.loadingShow();
          setTimeout(()=>{
            this.commonService.loadingHide();
            this.apiService.checkUserSessionApi().subscribe((data: any)=>{ 
              if(data.status == 1){
                // Put your function here
                this.deleteSelctedAddress(addressData['addressId']);
                this.close();
              }
            },error =>{
              this.commonService.loadingHide();
              console.log('Error in checking user session', error);   
            })
          },2000);
        }
      })   
    }
  }
  //Delete address from address list
  deleteSelctedAddress(id:any){
    this.commonService.loadingShow();
    this.apiService.deleteAddress(id).then((res: any)=>{
      this.commonService.loadingHide();
      if(res == '' || res == null){
        for (let i = 0; i < this.apiService.apiMainObj.alladdress.length; i++){
          if(this.apiService.apiMainObj.alladdress[i].addressId === id){
            this.addressDeleted = true;
            this.apiService.apiMainObj.alladdress.splice(i,1);
            if (this.apiService.apiMainObj.alladdress.length == 0) {
              //if(this.apiService.apiMainObj.address_type_id == '3' ){
              if(this.apiService.apiMainObj.isShippingChecked == true ){
                this.apiService.apiMainObj.selectedShippingAddress = {};
              }
              //if(this.apiService.apiMainObj.address_type_id == '2'){
              if(this.apiService.apiMainObj.isBillingChecked == true){
                this.apiService.apiMainObj.selectedBillingAddress = {};
              }
              //if(this.apiService.apiMainObj.address_type_id == '1'){
              if(this.apiService.apiMainObj.isDesignerChecked == true){
                this.apiService.apiMainObj.selectedDesignerAddress = {};
              }
            }
            break;
          }
        }
        if (this.apiService.apiMainObj.selectedShippingAddress && id == this.apiService.apiMainObj.selectedShippingAddress.addressId){
          this.apiService.apiMainObj.selectedShippingAddress = {};
          this.selectedShippingAddressId = 'no_id';
        }
        if (this.apiService.apiMainObj.selectedBillingAddress && id == this.apiService.apiMainObj.selectedBillingAddress.addressId){
          this.apiService.apiMainObj.selectedBillingAddress = {};
          this.selectedBillingAddressId = 'no_id';
        }
        if (this.apiService.apiMainObj.selectedDesignerAddress && id == this.apiService.apiMainObj.selectedDesignerAddress.addressId){
          this.apiService.apiMainObj.selectedDesignerAddress = {};
          this.selectedDesignerAddressId = 'no_id';
        }
      }
      this.apiService.getAllAddress('list').then(()=>{
        if(this.apiService.apiMainObj.alladdress.length==0){
          this.isChangeBtnDisable = true;
        }else{
          this.isChangeBtnDisable = false;
        }
      });
      this.checkTaxResale();
      this.shippingMethod('');
    });
    // this.modelController.dismiss();
  }
  
  addorEditAddress(content:any, addressID:any, typeofOpen:any){
    this.commonService.sessionPortalLoad();
    this.commonService.loadingShow();
    this.commonService.sessionPortalLoad();
    setTimeout(()=>{
      this.commonService.sessionPortalLoad();
      this.apiService.checkUserSessionApi().subscribe((data: any)=>{
        this.commonService.loadingHide();
        if(data.status == 1){
          this.callAddOrEditAddressLogic(content,addressID,typeofOpen );
        }
      },error =>{
        console.log('Error in checking user session', error);
      })
    },2000);
  }

  //ADD or EDIT address Modal Open
  callAddOrEditAddressLogic(content:any, addressID:any, typeofOpen:any){
    if(addressID != ''){
      this.close();
    }
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', windowClass:'Address-Modal'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

    if(typeofOpen == 'AddNewAddress'){
      this.apiService.apiMainObj.shippingAddressPopup = false;
      this.apiService.apiMainObj.billingAddressPopup = false;
      this.apiService.apiMainObj.designerAddressPopup = false;
      this.apiService.apiMainObj.addressAction = "Add address";
      this.apiService.apiMainObj.addressBtnText = "Add";
      this.commonService.commonMainObj.addressEditPopup = true;

      this.apiService.apiMainObj.contact_company="";
      this.apiService.apiMainObj.contact_email="";
      //this.apiService.contact_fax="";
      this.apiService.apiMainObj.contact_state="";
      this.apiService.apiMainObj.contact_city="";
      this.apiService.apiMainObj.contact_country="";
      // this.apiService.apiMainObj.address_type_id="";
      this.apiService.apiMainObj.isShippingChecked = false;
      this.apiService.apiMainObj.isBillingChecked = false;
      this.apiService.apiMainObj.isDesignerChecked = false;
      this.apiService.apiMainObj.contact_first_name="";
      this.apiService.apiMainObj.contact_last_name="";
      this.apiService.apiMainObj.contact_address1="";
      this.apiService.apiMainObj.contact_address2="";
      this.apiService.apiMainObj.contact_zipcode="";
      this.apiService.apiMainObj.contact_phone="";
      //this.apiService.default_add_address=0;
      //this.apiService.add_to_all_address = false;
      //this.defaultAddressCheck = false;
      this.createAddressForm.reset();
      this.addressEmailisValid = false;
      this.apiService.apiMainObj.contact_country = this.apiService.apiMainObj.defaultCountry;
      this.apiService.apiMainObj.contact_state = this.apiService.apiMainObj.defaultState;
      this.apiService.apiMainObj.contact_city = this.apiService.apiMainObj.defaultCity;
      
      if(this.apiService.apiMainObj.contact_country == "United States"){
        if (this.apiService.apiMainObj.contact_state == "California" || this.apiService.apiMainObj.contact_state == "CA") {
          this.showCityInputText = false;
          this.createAddressForm.controls["adState"].setValidators([Validators.minLength(2)]);
          this.createAddressForm.controls["adCity"].setValidators([Validators.minLength(2)]);
          this.createAddressForm.controls["adState"].updateValueAndValidity();
          this.createAddressForm.controls["adCity"].updateValueAndValidity();
        }else{
          this.showCityInputText = true;
          this.createAddressForm.controls["adCity"].setValidators([Validators.required,Validators.minLength(2)]);
          this.createAddressForm.controls["adCity"].updateValueAndValidity();
        }
      }else{
        this.showCityInputText = true;
        this.createAddressForm.controls["adState"].setValidators([Validators.required,Validators.minLength(2)]);
        this.createAddressForm.controls["adCity"].setValidators([Validators.required,Validators.minLength(2)]);
        this.createAddressForm.controls["adState"].updateValueAndValidity();
        this.createAddressForm.controls["adCity"].updateValueAndValidity();
      }
    }else if(typeofOpen == 'EditAddress'){
      this.apiService.apiMainObj.shippingAddressPopup = false;
      this.apiService.apiMainObj.billingAddressPopup = false;
      this.apiService.apiMainObj.designerAddressPopup = false;
      this.apiService.apiMainObj.addressAction = "Edit address";
      this.apiService.apiMainObj.addressBtnText = "Save";
      this.commonService.commonMainObj.addressEditPopup = false;
      this.addressEmailisValid = false;
      if (addressID != ''){
        this.editSelectedAdId = addressID;
        for(let i=0; i<this.apiService.apiMainObj.alladdress.length;i++){
          if(this.apiService.apiMainObj.alladdress[i].addressId == addressID){
            this.apiService.apiMainObj.address_id = this.apiService.apiMainObj.alladdress[i].addressId;
            this.apiService.apiMainObj.contact_first_name = this.apiService.apiMainObj.alladdress[i].firstName;
            this.apiService.apiMainObj.contact_last_name = this.apiService.apiMainObj.alladdress[i].lastName;
            this.apiService.apiMainObj.contact_address1 = this.apiService.apiMainObj.alladdress[i].addressLine1;
            this.apiService.apiMainObj.contact_address2 = this.apiService.apiMainObj.alladdress[i].addressLine2;
            this.apiService.apiMainObj.contact_state = this.apiService.apiMainObj.alladdress[i].state;
            this.apiService.apiMainObj.contact_city = this.apiService.apiMainObj.alladdress[i].city;
            this.apiService.apiMainObj.contact_country = this.apiService.apiMainObj.alladdress[i].country;
            this.apiService.apiMainObj.contact_zipcode = this.apiService.apiMainObj.alladdress[i].zip;
            this.apiService.apiMainObj.contact_phone = this.apiService.apiMainObj.alladdress[i].phoneNumber;
            this.apiService.apiMainObj.default_add_address = this.apiService.apiMainObj.alladdress[i].default == "1" ? true:false;
            this.apiService.apiMainObj.contact_user_id = this.apiService.apiMainObj.alladdress[i].userId;
            this.apiService.apiMainObj.contact_email = this.apiService.apiMainObj.alladdress[i].email;
            this.apiService.apiMainObj.contact_company = this.apiService.apiMainObj.alladdress[i].companyName;
            // this.apiService.apiMainObj.address_type_id = [];
            // (this.apiService.apiMainObj.alladdress[i]['isDefaultForShipping'] == '1'?this.apiService.apiMainObj.address_type_id.push('3'):'');
            // (this.apiService.apiMainObj.alladdress[i]['isDefaultForBilling'] == '1'?this.apiService.apiMainObj.address_type_id.push('2'):'');
            // (this.apiService.apiMainObj.alladdress[i]['isDefaultForDesign'] == '1'?this.apiService.apiMainObj.address_type_id.push('1'):'');
            this.apiService.apiMainObj.alladdress[i]['isDefaultForShipping'] == '1'? this.apiService.apiMainObj.isShippingChecked = true : this.apiService.apiMainObj.isShippingChecked = false;
            this.apiService.apiMainObj.alladdress[i]['isDefaultForBilling'] == '1'? this.apiService.apiMainObj.isBillingChecked = true : this.apiService.apiMainObj.isBillingChecked = false;
            this.apiService.apiMainObj.alladdress[i]['isDefaultForDesign'] == '1'? this.apiService.apiMainObj.isDesignerChecked = true : this.apiService.apiMainObj.isDesignerChecked = false;
          }
        }
      }
      if(this.apiService.apiMainObj.contact_country == "United States"){
        if (this.apiService.apiMainObj.contact_state == "California" || this.apiService.apiMainObj.contact_state == "CA") {
          this.showCityInputText = false;
          this.createAddressForm.controls["adState"].setValidators([Validators.minLength(2)]);
          this.createAddressForm.controls["adCity"].setValidators([Validators.minLength(2)]);
          this.createAddressForm.controls["adState"].updateValueAndValidity();
          this.createAddressForm.controls["adCity"].updateValueAndValidity();
        }
        else{
          this.showCityInputText = true;
          this.createAddressForm.controls["adCity"].setValidators([Validators.required,Validators.minLength(2)]);
          this.createAddressForm.controls["adCity"].updateValueAndValidity();
        }
      }else{
        this.showCityInputText = true;
        this.createAddressForm.controls["adState"].setValidators([Validators.required,Validators.minLength(2)]);
        this.createAddressForm.controls["adCity"].setValidators([Validators.required,Validators.minLength(2)]);
        this.createAddressForm.controls["adState"].updateValueAndValidity();
        this.createAddressForm.controls["adCity"].updateValueAndValidity();
      }
    }
  }

  addAddressSessionChecked(eventType:any,address_data_body:any){
    this.commonService.sessionPortalLoad();
    this.apiService.checkUserSessionApi().subscribe((data: any)=>{
      if(data.status == 1){
        if(eventType == 'new'){
          this.close();
          this.commonService.loadingHide();
          this.newResponseAddress(address_data_body,'new');
        }else{
          this.newResponseAddress(address_data_body,'update');
        }
      }
    },error =>{
      console.log('Error in checking user session', error);   
    })
  }

  // Add address API call
  addAddress(){
    this.commonService.sessionPortalLoad();
    this.commonService.loadingShow();
    let address_data_body = {
      "firstname":this.apiService.apiMainObj.contact_first_name,
      "lastname":this.apiService.apiMainObj.contact_last_name, 
      "email":this.apiService.apiMainObj.contact_email, 
      "phone":this.apiService.apiMainObj.contact_phone,
      // "fax":this.apiService.contact_fax,
      "fax":'',
      "address1": this.apiService.apiMainObj.contact_address1 , 
      "address2" : this.apiService.apiMainObj.contact_address2,
      "city":this.apiService.apiMainObj.contact_city ,
      "country":this.apiService.apiMainObj.contact_country, 
      "state":this.apiService.apiMainObj.contact_state,
      "zip":this.apiService.apiMainObj.contact_zipcode,
      "defaultForType":'0',
      "company":this.apiService.apiMainObj.contact_company,
      // "isDefaultForShipping": this.apiService.apiMainObj.address_type_id? (this.apiService.apiMainObj.address_type_id.join().indexOf('3')>-1? '1': '0'): '0',
      // "isDefaultForBilling": this.apiService.apiMainObj.address_type_id? (this.apiService.apiMainObj.address_type_id.join().indexOf('2')>-1? '1': '0'): '0',
      // "isDefaultForDesign": this.apiService.apiMainObj.address_type_id? (this.apiService.apiMainObj.address_type_id.join().indexOf('1')>-1? '1': '0'): '0'
      "isDefaultForShipping": this.apiService.apiMainObj.isShippingChecked?  '1' : '0',
      "isDefaultForBilling": this.apiService.apiMainObj.isBillingChecked? '1': '0',
      "isDefaultForDesign": this.apiService.apiMainObj.isDesignerChecked? '1': '0'
    };

    if(this.commonService.commonMainObj.addressEditPopup){
      this.apiService.addNewAddressNew('',address_data_body).then((res: any)=>{
        this.addAddressSessionChecked('new',address_data_body) ;       
        // this.checkTaxResale();
        // this.shippingMethod('');
        // if (modalElement.data['status'] == 'save') {
        //   for(let k in this.remoteService.addressTypeIdMultiple){
        //     if (this.remoteService.addressTypeIdMultiple[k]=='3') {
        //       this.checkTaxResale();
        //       this.shippingMethod('');
        //     }
        //   }
        // }
      });
    }else{
      this.updateNewAddressDetailsRep(this.editSelectedAdId);
      this.commonService.loadingHide();
      setTimeout(() => {
        this.close();
      }, 1000);
    }
    
   }
// Update edited address API call
  updateNewAddressDetailsRep(addressId:any){
    this.apiService.updateNewAddressDetails(addressId).subscribe((updateData:any)=>{
      this.addAddressSessionChecked('update',updateData);
      // this.checkTaxResale();
      // this.shippingMethod('');
    });
  }

  viewDeliverToAddress(selectedAddressData:any,adl:any){
    for (let index = 0; index < this.apiService.apiMainObj.alladdress.length; index++) {
      this.apiService.apiMainObj.alladdress[index]['isCheckedDeliver'] = null;
      $('#selectAdd_'+ this.apiService.apiMainObj.alladdress[index].addressId).show();
      $('#selcted_lbl_'+ this.apiService.apiMainObj.alladdress[index].addressId).removeClass('selectedCard');
      $('#ac_'+ this.apiService.apiMainObj.alladdress[index].addressId).removeClass( 'active-box' );
      if (this.apiService.apiMainObj.alladdress[index].addressId == selectedAddressData.addressId){
        this.deliverToAddress(this.apiService.apiMainObj.alladdress[index],index,'click')
      }
    }
  }
  deliverToAddress(selectedAddressData:any,adl:any,route:any) {
    let selectedIndex = -1;
    if (this.apiService.apiMainObj.alladdress[adl].addressId == selectedAddressData.addressId){
      selectedIndex = adl;
      $('#selectAdd_'+selectedAddressData.addressId).hide();
      $('#selcted_lbl_'+selectedAddressData.addressId).addClass('selectedCard');
      $('#ac_'+ this.apiService.apiMainObj.alladdress[adl].addressId).addClass( 'active-box' );
    }else{
      $('#selectAdd_'+ this.apiService.apiMainObj.alladdress[adl].addressId).show();
      $('#selcted_lbl_'+ this.apiService.apiMainObj.alladdress[adl].addressId).removeClass('selectedCard');
      $('#ac_'+ this.apiService.apiMainObj.alladdress[adl].addressId).removeClass( 'active-box' );
    } 

    if (this.apiService.apiMainObj.shippingAddressPopup){
      this.selectedShippingAddressId = selectedAddressData.addressId;
    }
    if (this.apiService.apiMainObj.billingAddressPopup){
      this.selectedBillingAddressId = selectedAddressData.addressId;
    }
    if (this.apiService.apiMainObj.designerAddressPopup){
      this.selectedDesignerAddressId = selectedAddressData.addressId;
    }

    if (route != 'click') {
      this.apiService.apiMainObj.alladdress.splice(0,0,this.apiService.apiMainObj.alladdress[adl]);
      this.apiService.apiMainObj.alladdress.splice(Number(adl)+1,1);
    }
  }
  close() {
    this.modalService.dismissAll();
  }
  
  selectAddress(){
    this.close();
    if (this.apiService.apiMainObj.shippingAddressPopup){
      if (this.selectedShippingAddressId == 'no_id'){
        alert('Please select a shipping address');
      }else{
        let defaultCheck = false;
        for (let i = 0; i < this.apiService.apiMainObj.alladdress.length; i++){
          if(this.apiService.apiMainObj.alladdress[i].isCheckedDeliver !=null){
            defaultCheck = true;
          }
          if (this.apiService.apiMainObj.alladdress[i].addressId == this.selectedShippingAddressId){
              this.apiService.apiMainObj.address_id = this.apiService.apiMainObj.alladdress[i].addressId ;
              this.apiService.apiMainObj.isShippingChecked = true;
              this.apiService.apiMainObj.alladdress[i].isDefaultForBilling == "1"? this.apiService.apiMainObj.isBillingChecked = true : this.apiService.apiMainObj.isBillingChecked =false;
              this.apiService.apiMainObj.alladdress[i].isDefaultForDesign == "1"? this.apiService.apiMainObj.isDesignerChecked = true : this.apiService.apiMainObj.isDesignerChecked =false;
              this.apiService.apiMainObj.contact_first_name = this.apiService.apiMainObj.alladdress[i].firstName ;
              this.apiService.apiMainObj.contact_last_name = this.apiService.apiMainObj.alladdress[i].lastName ;
              this.apiService.apiMainObj.contact_email = this.apiService.apiMainObj.alladdress[i].email ;
              this.apiService.apiMainObj.contact_phone = this.apiService.apiMainObj.alladdress[i].phoneNumber ;
              this.apiService.apiMainObj.contact_company = this.apiService.apiMainObj.alladdress[i].companyName ;
              this.apiService.apiMainObj.contact_address1 = this.apiService.apiMainObj.alladdress[i].addressLine1 ;
              this.apiService.apiMainObj.contact_address2 = this.apiService.apiMainObj.alladdress[i].addressLine2 ;
              this.apiService.apiMainObj.contact_city = this.apiService.apiMainObj.alladdress[i].city ;
              this.apiService.apiMainObj.contact_country = this.apiService.apiMainObj.alladdress[i].country ;
              this.apiService.apiMainObj.contact_state = this.apiService.apiMainObj.alladdress[i].state ;
              this.apiService.apiMainObj.contact_zipcode = this.apiService.apiMainObj.alladdress[i].zip ;

              this.makingDefaultAddress(this.apiService.apiMainObj.address_id);
          }

        }
        if(!defaultCheck && this.apiService.apiMainObj.alladdress.length == 0){
          this.apiService.apiMainObj.selectedShippingAddress = {};
          //this.modelController.dismiss(this.addressDeleted,'save');
        }
      }
    }
    if (this.apiService.apiMainObj.billingAddressPopup){
      if (this.selectedBillingAddressId == 'no_id'){
        alert('Please select a billing address');
      }else{
        let defaultCheck = false;
        for (let i = 0; i < this.apiService.apiMainObj.alladdress.length; i++){
          if(this.apiService.apiMainObj.alladdress[i].isCheckedDeliver !=null){
            defaultCheck = true;
          }
          if (this.apiService.apiMainObj.alladdress[i].addressId == this.selectedBillingAddressId){
              this.apiService.apiMainObj.address_id = this.apiService.apiMainObj.alladdress[i].addressId ;
              // this.apiService.apiMainObj.address_type_id = [] ;
              // this.apiService.apiMainObj.alladdress[i].isDefaultForShipping == "1"? this.apiService.apiMainObj.address_type_id.push('3'):'0';
              // this.apiService.apiMainObj.address_type_id.push('2');
              // this.apiService.apiMainObj.alladdress[i].isDefaultForDesign == "1"? this.apiService.apiMainObj.address_type_id.push('1'):'0';
              this.apiService.apiMainObj.alladdress[i].isDefaultForShipping == "1"? this.apiService.apiMainObj.isShippingChecked = true : this.apiService.apiMainObj.isShippingChecked = false;
              this.apiService.apiMainObj.isBillingChecked = true ;
              this.apiService.apiMainObj.alladdress[i].isDefaultForDesign == "1"? this.apiService.apiMainObj.isDesignerChecked = true : this.apiService.apiMainObj.isDesignerChecked = false;
              
              this.apiService.apiMainObj.contact_first_name = this.apiService.apiMainObj.alladdress[i].firstName ;
              this.apiService.apiMainObj.contact_last_name = this.apiService.apiMainObj.alladdress[i].lastName ;
              this.apiService.apiMainObj.contact_email = this.apiService.apiMainObj.alladdress[i].email ;
              this.apiService.apiMainObj.contact_phone = this.apiService.apiMainObj.alladdress[i].phoneNumber ;
              this.apiService.apiMainObj.contact_company = this.apiService.apiMainObj.alladdress[i].companyName ;
              this.apiService.apiMainObj.contact_address1 = this.apiService.apiMainObj.alladdress[i].addressLine1 ;
              this.apiService.apiMainObj.contact_address2 = this.apiService.apiMainObj.alladdress[i].addressLine2 ;
              this.apiService.apiMainObj.contact_city = this.apiService.apiMainObj.alladdress[i].city ;
              this.apiService.apiMainObj.contact_country = this.apiService.apiMainObj.alladdress[i].country ;
              this.apiService.apiMainObj.contact_state = this.apiService.apiMainObj.alladdress[i].state ;
              this.apiService.apiMainObj.contact_zipcode = this.apiService.apiMainObj.alladdress[i].zip ;
              this.apiService.apiMainObj.default_add_address = true ;

              this.makingDefaultAddress(this.apiService.apiMainObj.address_id);
          }

        }
        if(!defaultCheck && this.apiService.apiMainObj.alladdress.length == 0){
          this.apiService.apiMainObj.selectedBillingAddress = {};
          //this.modelController.dismiss();
        }
      }
    }
    if (this.apiService.apiMainObj.designerAddressPopup){
      if (this.selectedDesignerAddressId == 'no_id'){
        alert('Please select a designer address');
      }else{
        let defaultCheck = false;
        for (let i = 0; i < this.apiService.apiMainObj.alladdress.length; i++){
          if(this.apiService.apiMainObj.alladdress[i].isCheckedDeliver !=null){
            defaultCheck = true;
          }
          if (this.apiService.apiMainObj.alladdress[i].addressId == this.selectedDesignerAddressId){
              this.apiService.apiMainObj.address_id = this.apiService.apiMainObj.alladdress[i].addressId ;
              // this.apiService.apiMainObj.address_type_id = [] ;
              // this.apiService.apiMainObj.alladdress[i].isDefaultForShipping == "1"? this.apiService.apiMainObj.address_type_id.push('3'):'0';
              // this.apiService.apiMainObj.alladdress[i].isDefaultForBilling == "1"? this.apiService.apiMainObj.address_type_id.push('2'):'0';
              // this.apiService.apiMainObj.address_type_id.push('1');
              this.apiService.apiMainObj.alladdress[i].isDefaultForShipping == "1"? this.apiService.apiMainObj.isShippingChecked = true : this.apiService.apiMainObj.isShippingChecked = false;
              this.apiService.apiMainObj.alladdress[i].isDefaultForBilling == "1"? this.apiService.apiMainObj.isBillingChecked = true : this.apiService.apiMainObj.isBillingChecked = false;
              this.apiService.apiMainObj.isDesignerChecked = true;
              this.apiService.apiMainObj.contact_first_name = this.apiService.apiMainObj.alladdress[i].firstName ;
              this.apiService.apiMainObj.contact_last_name = this.apiService.apiMainObj.alladdress[i].lastName ;
              this.apiService.apiMainObj.contact_email = this.apiService.apiMainObj.alladdress[i].email ;
              this.apiService.apiMainObj.contact_phone = this.apiService.apiMainObj.alladdress[i].phoneNumber ;
              this.apiService.apiMainObj.contact_company = this.apiService.apiMainObj.alladdress[i].companyName ;
              this.apiService.apiMainObj.contact_address1 = this.apiService.apiMainObj.alladdress[i].addressLine1 ;
              this.apiService.apiMainObj.contact_address2 = this.apiService.apiMainObj.alladdress[i].addressLine2 ;
              this.apiService.apiMainObj.contact_city = this.apiService.apiMainObj.alladdress[i].city ;
              this.apiService.apiMainObj.contact_country = this.apiService.apiMainObj.alladdress[i].country ;
              this.apiService.apiMainObj.contact_state = this.apiService.apiMainObj.alladdress[i].state ;
              this.apiService.apiMainObj.contact_zipcode = this.apiService.apiMainObj.alladdress[i].zip ;
              this.apiService.apiMainObj.default_add_address = true ;

              this.makingDefaultAddress(this.apiService.apiMainObj.address_id);
          }

        }
        if(!defaultCheck && this.apiService.apiMainObj.alladdress.length == 0){
          this.apiService.apiMainObj.selectedDesignerAddress = {};
          //this.modelController.dismiss();
        }
      }
    }
  }
  makingDefaultAddress(addressId:any){
    this.apiService.updateNewAddressDetails(addressId).subscribe((data:any)=>{
      // this.newResponseAddress(data,'update');
      if (data) {
        let newAddressObj = {
          firstName        :data.firstname,
          lastName         :data.lastname,
          addressLine1     :data.address1,
          addressLine2     :data.address2,
          city             :data.city,
          state            :data.state,
          country          :data.country,
          zip              :data.zip,
          phoneNumber      :data.phone,
          fax              :data.fax, 
          // default          :data.defaultForType,
          addressId        :data.addressid,
          // addressTypeId    :data.addressType,
          email            :data.email,
          companyName      :data.company,
          isDefaultForBilling :data.isDefaultForBilling,
          isDefaultForDesign  :data.isDefaultForDesign,
          isDefaultForShipping:data.isDefaultForShipping
        }
        if (this.apiService.apiMainObj.shippingAddressPopup){
          this.apiService.apiMainObj.selectedShippingAddress = newAddressObj;
          //this.modelController.dismiss(true,'save');
        }
        if (this.apiService.apiMainObj.billingAddressPopup){
          this.apiService.apiMainObj.selectedBillingAddress = newAddressObj;
          //this.modelController.dismiss();
        }
        if (this.apiService.apiMainObj.designerAddressPopup){
          this.apiService.apiMainObj.selectedDesignerAddress = newAddressObj;
          //this.modelController.dismiss();
        }
        this.apiService.getAllAddress('list').then(()=>{
          if(this.apiService.apiMainObj.alladdress.length==0){
            this.isChangeBtnDisable = true;
          }else{
            this.isChangeBtnDisable = false;
          }
        });
        this.checkTaxResale();
        this.shippingMethod('');
      }
    });
  }
  newResponseAddress(address_data_body:any,path:any){
    let newAddressObj: any = {};
    let shippaddress: boolean = false;
    if (path == 'new') {
      newAddressObj = {
        firstName        :address_data_body.firstname,
        lastName         :address_data_body.lastname,
        companyName      :address_data_body.company,
        addressLine1     :address_data_body.address1,
        addressLine2     :address_data_body.address2,
        city             :address_data_body.city,
        state            :address_data_body.state,
        country          :address_data_body.country,
        zip              :address_data_body.zip,
        phoneNumber      :address_data_body.phone,
        fax              :address_data_body.fax,
        // default          :address_data_body.defaultForType,
        //addressId        :address_data_body.addressId,
        // addressTypeId    :address_data_body.addressType,
        email            :address_data_body.email,
        isDefaultForBilling :address_data_body.isDefaultForBilling,
        isDefaultForDesign  :address_data_body.isDefaultForDesign,
        isDefaultForShipping:address_data_body.isDefaultForShipping
      }
      if(address_data_body.isDefaultForShipping == '1' || address_data_body.isDefaultForShipping == 1){
        this.apiService.apiMainObj.selectedShippingAddress = newAddressObj;
      }
      if(address_data_body.isDefaultForBilling == '1' || address_data_body.isDefaultForBilling == 1){
        this.apiService.apiMainObj.selectedBillingAddress = newAddressObj;
      }
      if(address_data_body.isDefaultForDesign == '1' || address_data_body.isDefaultForDesign == 1){
        this.apiService.apiMainObj.selectedDesignerAddress = newAddressObj;
      }
      //this.apiService.hideLoader();
    }else{
      if (address_data_body.isDefaultForShipping == '1') {
        shippaddress = true;
      }
      // this.apiService.getAddressDetails('list').then(()=>{});
      newAddressObj = {
        firstName        :address_data_body.firstname,
        lastName         :address_data_body.lastname,
        addressLine1     :address_data_body.address1,
        addressLine2     :address_data_body.address2,
        city             :address_data_body.city,
        state            :address_data_body.state,
        country          :address_data_body.country,
        zip              :address_data_body.zip,
        phoneNumber      :address_data_body.phone,
        fax              :address_data_body.fax, 
        // default          :address_data_body.defaultForType,
        addressId        :address_data_body.addressid,
        // addressTypeId    :address_data_body.addressType,
        email            :address_data_body.email,
        companyName      :address_data_body.company,
        isDefaultForBilling :address_data_body.isDefaultForBilling,
        isDefaultForDesign  :address_data_body.isDefaultForDesign,
        isDefaultForShipping:address_data_body.isDefaultForShipping
      }    
      if(address_data_body.isDefaultForShipping == '1' || address_data_body.isDefaultForShipping == 1 || address_data_body.isDefaultForShipping == "0"){
        this.apiService.apiMainObj.selectedShippingAddress = (newAddressObj.isDefaultForShipping == '1' || address_data_body.isDefaultForShipping == 1 )?newAddressObj:this.apiService.apiMainObj.selectedShippingAddress;
      }
      if(address_data_body.isDefaultForBilling == '1' || address_data_body.isDefaultForBilling == 1 || address_data_body.isDefaultForBilling == "0"){
        this.apiService.apiMainObj.selectedBillingAddress = (newAddressObj.isDefaultForBilling == '1' || address_data_body.isDefaultForBilling == 1 )?newAddressObj:this.apiService.apiMainObj.selectedBillingAddress;
      }
      if(address_data_body.isDefaultForDesign == '1' || address_data_body.isDefaultForDesign == 1 || address_data_body.isDefaultForDesign == "0"){
        this.apiService.apiMainObj.selectedDesignerAddress = (newAddressObj.isDefaultForDesign == '1' || address_data_body.isDefaultForDesign == 1 )?newAddressObj:this.apiService.apiMainObj.selectedDesignerAddress;
      }
    }
    this.apiService.getAllAddress('list').then(()=>{
      if(this.apiService.apiMainObj.alladdress.length==0){
        this.isChangeBtnDisable = true;
      }else{
        this.isChangeBtnDisable = false;
      } 
      // this.closeModal(path);
      // this.modelController.getTop().then(v => v ? this.modelController.dismiss({'status': 'save','type': shippaddress ?address_data_body:''}): null);
      this.checkTaxResale();
      this.shippingMethod('');
    });
  }
  multiSelect(selectedType:any){

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  //on Tax change start----------------------->
  tax_radio_changed(e:any){
    //if(!this.commonService.commonMainObj.isNotAuthChecked){
      if (e == 'Taxable'){
        this.commonService.commonMainObj.taxable = true;
        $('#TaxOption1').removeClass('tax-active');
        $('#TaxOption1').removeClass('radio-checked');
        $('#TaxOption0').addClass('tax-active');
        $('#TaxOption0').addClass('radio-checked');
        $('#TaxOption0').prop( "checked", true );
        $('#TaxOption1').prop( "checked", false );
        this.taxInfoUpdate();
      }else{
        this.commonService.commonMainObj.taxable = false;
        $('#TaxOption0').removeClass('tax-active');
        $('#TaxOption0').removeClass('radio-checked');
        $('#TaxOption1').addClass('tax-active');
        $('#TaxOption1').addClass('radio-checked');
        $('#TaxOption0').prop( "checked", false );
        $('#TaxOption1').prop( "checked", true );
        this.commonService.commonMainObj.taxableRate = "";
        this.commonService.commonMainObj.taxablePrice = "0.00";
        this.commonService.commonMainObj.assemblyTaxPrice = '0.00';
        this.commonService.commonMainObj.componentTaxPrice = '0.00';
      }
    //}
    this.resaleInfoUpdate();
    this.sel_tax_option = e;
  }
  taxInfoUpdate(){
    for(let i = 0; i < this.commonService.commonMainObj.taxInformation.length; i++){
      if(this.commonService.commonMainObj.taxInformation[i].city == this.apiService.apiMainObj.selectedShippingAddress.city){
        this.commonService.commonMainObj.taxableRate = this.commonService.commonMainObj.taxInformation[i].rate;
        let price = "";
        //need to check this------------------------------------------------------------------------------>
        // if(this.commonService.commonMainObj.selectedFabQuantity!=null && this.commonService.commonMainObj.unitPrice!=null && this.commonService.commonMainObj.electricalTestingPriceVal!=null){
        //   price = (( parseFloat( this.commonService.commonMainObj.unitPrice) * parseInt( this.commonService.commonMainObj.selectedFabQuantity ) )  + parseFloat(this.commonService.commonMainObj.electricalTestingPriceVal) ).toFixed(2)
        // }else{
        //   price = ""
        // }
        if(this.commonService.commonMainObj.OrdSumNumOfPcbs!=null && this.commonService.commonMainObj.orderSummery[0]?.unitPrice!=null && this.commonService.commonMainObj.ordSumEtestCharge!=null){
          price = (( parseFloat( this.commonService.commonMainObj.OrdSumPcbCharges ) )  + parseFloat(this.commonService.commonMainObj.electricalTesting == "Yes"?this.commonService.commonMainObj.ordSumEtestCharge : 0) ).toFixed(2)
        }else{
          price = ""
        }
        this.commonService.commonMainObj.taxablePrice = (parseFloat(price) * (this.commonService.commonMainObj.taxableRate/100)).toFixed(2);
        
      }
    }
  }
  resaleInfoUpdate(){
    if(!this.commonService.commonMainObj.backToOrderDetails){
      this.commonService.commonMainObj.resaleNumber = this.commonService.commonMainObj.resaleNumberDataFromAPi;
    }
  }
  checkTaxResale(){
    if (this.apiService.apiMainObj.selectedShippingAddress) {
      if (this.apiService.apiMainObj.selectedShippingAddress.country == 'United States' && (this.apiService.apiMainObj.selectedShippingAddress.state =='CA' || this.apiService.apiMainObj.selectedShippingAddress.state =='California')) {
        this.taxShowing.visible = true;
        setTimeout(()=>{
          if(this.commonService.commonMainObj.backToOrderDetails){
            if(this.commonService.commonMainObj.taxable){
              this.tax_radio_changed('Taxable');
            }else{
              this.tax_radio_changed('Non-taxable');
            }
          }else{
            this.tax_radio_changed('Taxable');
          }
          
        },500)
      }else{
        this.taxShowing.visible = false;
        this.commonService.commonMainObj.taxableRate = "";
        this.commonService.commonMainObj.taxablePrice = '0.00';
        this.commonService.commonMainObj.assemblyTaxPrice = '0.00';
        this.commonService.commonMainObj.componentTaxPrice = '0.00';
        if (this.apiService.apiMainObj.selectedShippingAddress.country != 'United States') {
          this.taxShowing.message = 'California';
        }else{
          if(this.apiService.apiMainObj.selectedShippingAddress.state !='CA' || this.apiService.apiMainObj.selectedShippingAddress.state !='California') {
            this.taxShowing.message = 'California';
          }
        }
      }
    }
  }
 
 //on Tax change End ------------------------>

 //Payment Related Starte
 selectedCardType(event:any){
  if(event){
    this.commonService.commonMainObj.selectedCreditCard = {"cardtype" :event.toString()}
  }
  if (event=='2'|| event=='3') {
    this.paymentForm.controls["cvv"].setValidators([Validators.required,Validators.minLength(4), Validators.maxLength(4)]);
    this.paymentForm.controls["cvv"].updateValueAndValidity();
    if (this.commonService.commonMainObj.cardCvvNumber) {
        this.commonService.commonMainObj.cardCvvNumber = '';
    }
  }else{
    this.paymentForm.controls["cvv"].setValidators([Validators.required,Validators.minLength(3), Validators.maxLength(3)]);
    this.paymentForm.controls["cvv"].updateValueAndValidity();
    if (this.commonService.commonMainObj.cardCvvNumber) {
        this.commonService.commonMainObj.cardCvvNumber = '';
    }
  }
    
}
cardNumber(enteredValue:any){
  let enteredCardNum =enteredValue.target.value;
  this.cardType = "";
  this.commonService.commonMainObj.cardType = this.cardType
  this.selectedCardType(enteredCardNum[0])
  if(enteredCardNum.startsWith("4")){
    this.commonService.commonMainObj.cardType = '3';
    $('#card_type').attr("src","../assets/img/visa.png");
    this.cardType = "Visa";
    this.commonService.commonMainObj.cardType = this.cardType
  }else if(enteredCardNum.startsWith("5")){
    this.commonService.commonMainObj.cardType = '4';
    $('#card_type').attr("src","../assets/img/mastercard.png");
    this.cardType = "MASTER";
    this.commonService.commonMainObj.cardType = this.cardType
  }else if(enteredCardNum.startsWith("3")){
    this.commonService.commonMainObj.cardType = '2';
    $('#card_type').attr("src","../assets/img/amaericanexpress.png");
    this.cardType = "American Express";
    this.commonService.commonMainObj.cardType = this.cardType
  }else if(enteredCardNum.startsWith("6")){
    this.commonService.commonMainObj.cardType = '1';
    $('#card_type').attr("src","../assets/img/discover.png");
    this.cardType = "Discover";
    this.commonService.commonMainObj.cardType = this.cardType
  }else{
    this.commonService.commonMainObj.cardType = '';
    $('#card_type').attr("src","");
  }
}
monthChanged(event:any){
  this.commonService.commonMainObj.selectedCardExpiryMonth = event;
  this.commonService.commonMainObj.cardExpiryDate = event.detail.value+'/'+this.commonService.commonMainObj.selectedCardExpiryYear;
}

yearChanged(eventValue:any){
  this.commonService.commonMainObj.selectedCardExpiryYear = eventValue;
  this.commonService.commonMainObj.cardExpiryDate = this.commonService.commonMainObj.selectedCardExpiryMonth+'/'+eventValue;
}
//Payment Related End

//Shipping Method Related Started
shippingMethod(loadType:any){
  //console.log("commonService.commonMainObj.selectedShippingAddress.state",this.commonService.commonMainObj.selectedShippingAddress.state);
  // if(this.commonService.commonMainObj.selectedShippingAddress.country != "" && this.commonService.commonMainObj.selectedShippingAddress.state != ""){
  if(this.apiService.apiMainObj.selectedShippingAddress.country){
    
    if(this.apiService.apiMainObj.selectedShippingAddress.country && this.apiService.apiMainObj.selectedShippingAddress.state){
      if(!loadType){
        //this.commonService.commonMainObj.showLoader();
        }
        this.apiService.getShippingOptions(loadType).then((res: any)=>{
          this.commonService.loadingHide();
          if(!loadType){
            setTimeout(()=>{
                //this.commonService.commonMainObj.hideLoader();
            },1200)
          }
          if(res && res.length>0){
            this.commonService.commonMainObj.shippingOptionResponse = [];
            setTimeout(()=>{
            this.commonService.commonMainObj.shippingOptionResponse = res;
            },200)
            
              setTimeout(()=>{
                if(!this.commonService.commonMainObj.backToOrderDetails){
                  this.commonService.commonMainObj.shippingMethod = this.commonService.commonMainObj.shippingOptionResponse[0].shippingID;
                }
                this.slectedShipping(this.commonService.commonMainObj.shippingMethod);
                $('#shipMethod').removeAttr('disabled');
                
              },500)
            
          }else{
            this.commonService.commonMainObj.shippingOptionResponse = [];
          }
        });
      // }
    }
    
  }else{
    this.commonService.commonMainObj.shippingMethod = '';
    this.commonService.commonMainObj.shippingCost = "0.00";
    this.commonService.commonMainObj.shippingOptionResponse = [];
    $('#shipMethod').attr('disabled','true');
  }
}
slectedShipping(shippingvalue:any){
    const shipId = shippingvalue.detail?shippingvalue.detail.value:shippingvalue.toString();
    for(let i = 0; i < this.commonService.commonMainObj.shippingOptionResponse.length; i++){
      if(this.commonService.commonMainObj.shippingOptionResponse[i].shippingID == shipId){
        let shippingPrice = this.commonService.commonMainObj.shippingOptionResponse[i].shippingPrice;
        this.commonService.commonMainObj.tempShippingCost = shippingPrice;
        if (!this.commonService.commonMainObj.shippingAccountNumber){
          this.commonService.commonMainObj.shippingCost = shippingPrice;
        }
      }
    } 
}
accountNumberEdit(event:any){
  if(event){
    this.commonService.commonMainObj.shippingCost = "0.00"
  }else{
    this.commonService.commonMainObj.shippingCost = this.commonService.commonMainObj.tempShippingCost;
  }
}
//Shipping Method Related Started

//ON CLICK ON CONTINUE NEXT
orderDetailsContinue(){
  let message = "";
    if ((!message) &&(!this.apiService.apiMainObj.selectedShippingAddress.country)){
        message = "Please Add/Select valid shipping address";
    }
    if ((!message) &&(!this.apiService.apiMainObj.selectedBillingAddress.firstName)){
        message = "Please Add/Select valid billing address";
    }
    if ((!message) &&(!this.apiService.apiMainObj.selectedDesignerAddress.country)){
        message = "Please Add/Select valid designer address";
    }
    // if ((!message) && (this.apiService.apiMainObj.selectedShippingAddress.country == "United States") && (this.commonService.commonMainObj.shippingMethod == '3' || this.commonService.commonMainObj.shippingMethod == '4' || this.commonService.commonMainObj.shippingMethod == '5' || this.commonService.commonMainObj.shippingMethod == '6' || this.commonService.commonMainObj.shippingMethod == '7' || this.commonService.commonMainObj.shippingMethod == '18') && (!this.commonService.commonMainObj.shippingAccountNumber)){
    // if ((!message) && (this.apiService.apiMainObj.selectedShippingAddress.country == "United States") && (this.commonService.commonMainObj.shippingMethod == '5' || this.commonService.commonMainObj.shippingMethod == '18') && (!this.commonService.commonMainObj.shippingAccountNumber)){
    //   this.shippingAccNum.nativeElement.focus();
    //   $('#ship_account').addClass('border-red');
    //   message = "Shipping Account # is mandatory for UPS Next Day AM/ FedEx First Overnight delivery method.";
    // }
    if ((!message) && (this.apiService.apiMainObj.selectedShippingAddress.country != "United States") && (!this.commonService.commonMainObj.shippingAccountNumber)){
      this.shippingAccNum.nativeElement.focus();
      $('#ship_account').addClass('border-red');
      message = "You are shipping internationally and we will need your shipping account number to do so.";
    }
    if ((!message) &&(this.commonService.commonMainObj.shippingMethod == null || this.commonService.commonMainObj.shippingMethod == undefined || this.commonService.commonMainObj.shippingMethod == "")){
      message = "Please fill all the shipping details";
    }
    if(this.apiService.apiMainObj.selectedShippingAddress.state =='CA' || this.apiService.apiMainObj.selectedShippingAddress.state =='California' && !this.commonService.commonMainObj.isNotAuthChecked){
      if((!message) && ($('#TaxOption0').hasClass("tax-active")) == false && ($('#TaxOption1').hasClass("tax-active")) == false ){
        message = "Please select tax information";
      }
      // else if((!message) && (this.sel_tax_option =='Non-Taxable' && this.commonService.commonMainObj.resaleNumber == "" || this.commonService.commonMainObj.resaleNumber == undefined)){
      //   message = "Please fill at least one Tax information.";
      // }
    }
    if(this.sel_tax_option =='Non-taxable' && !this.commonService.commonMainObj.isNotAuthChecked){
      if((!message) && (this.commonService.commonMainObj.resaleNumber == "" || this.commonService.commonMainObj.resaleNumber == undefined) ){
        if((!message) && (this.commonService.commonMainObj.taxExemptCertiNumber == "" || this.commonService.commonMainObj.taxExemptCertiNumber == undefined) ){
          if((!message) && (this.commonService.commonMainObj.taxExemptOutsideCalifornia == "" || this.commonService.commonMainObj.taxExemptOutsideCalifornia == undefined) ){
            this.resaleSec.nativeElement.focus();
            message = "Please fill at least one Tax & Resale information";
          }
        }
      }
    }
    if(this.commonService.commonMainObj.isNotAuthChecked){
      if((!message) && (this.commonService.commonMainObj.purchasingPersonDetails.firstName == "" || this.commonService.commonMainObj.purchasingPersonDetails.firstName == undefined) ){
        this.authFistName.nativeElement.focus();
        message = "Please enter purchasing person Name";
        //message = "Please agree the pending payment terms.";
      }
      // if((!message) && (this.commonService.commonMainObj.purchasingPersonDetails.lastName == "" || this.commonService.commonMainObj.purchasingPersonDetails.lastName == undefined) ){
      //   this.authLastName.nativeElement.focus();
      //   return;
      //   //message = "Please agree the pending payment terms.";
      // }
      if((!message) && (this.commonService.commonMainObj.purchasingPersonDetails.email == "" || this.commonService.commonMainObj.purchasingPersonDetails.email == undefined) ){
        message = "Please enter purchasing person email";
        this.authEmail.nativeElement.focus();
        //message = "Please agree the pending payment terms.";
      }else if((!message) && (!/^(?!\.)(?!.*\.\.)[a-zA-Z0-9_.-]{1,64}(?<!\.)@(?!(?:.*-[0-9]+\.){2,})(?=[a-zA-Z0-9-]{1,61}\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,63}$/.test(this.commonService.commonMainObj.purchasingPersonDetails.email)) ){
        message = "Please enter valid purchasing person email";
        this.authEmail.nativeElement.focus();
        //message = "Please agree the pending payment terms.";
      }
      if((!message) && (!this.commonService.commonMainObj.purchasingPersonDetails.paymentPending) ){
        $('.agree-check').addClass('red-brd');
        //this.authAgreed.nativeElement.focus();
        message = "Please agree the pending payment terms.";
      }
    }
    if(message){
      Swal.fire({
        title: 'Required fields should not be empty',
        text: message,
        //icon: 'warning',
        showCloseButton: true,
        confirmButtonText: 'Ok'
      }).then((result) => {
        if (result['isConfirmed']){
          return
        }
      })
    }else{
      // if(!this.commonService.commonMainObj.isNotAuthChecked){
        this.addorEditCreditcard();
      // }
    }    
}
get pf() { return this.paymentForm.controls; }
addorEditCreditcard(){
  this.commonService.sessionPortalLoad();
  this.paymentSubmitForm = true;
  let message = "";
  this.commonService.commonMainObj.cardExpiryDate = this.commonService.commonMainObj.selectedCardExpiryMonth+'/'+this.commonService.commonMainObj.selectedCardExpiryYear;
  let dateRegEx1 = new RegExp(/^(0?[1-9]|1[012])[\/\-]\d{4}$/);
  if ((!message) && (this.commonService.commonMainObj.cardHolderName == null
    || this.commonService.commonMainObj.cardHolderName==undefined
    || this.commonService.commonMainObj.cardHolderName==""
    || this.commonService.commonMainObj.cardHolderName=="")){
      $('#name_on_card').addClass('border-red');
      this.cardName.nativeElement.focus();
      message = "Card holder name is required";
      $("#name_on_card").focus();
  }else{
    let km = new RegExp(/^[a-zA-Z ]+$/)
    if(km.test(this.commonService.commonMainObj.cardHolderName) == false){
      this.cardName.nativeElement.focus();
      message = "Card holder name must be in alphabet";
      $("#name_on_card").focus();
    }
  }
  if ((!message) && (this.commonService.commonMainObj.cardNumber == null
    || this.commonService.commonMainObj.cardNumber==undefined
    || this.commonService.commonMainObj.cardNumber=="")){
      $('#card_number').addClass('border-red');
      this.cardNum.nativeElement.focus();
      message = "Card number is required";
  }
  if ((!message) && (this.commonService.commonMainObj.selectedCardExpiryMonth == null
    || this.commonService.commonMainObj.selectedCardExpiryMonth==undefined
    || this.commonService.commonMainObj.selectedCardExpiryMonth=="")){
      message = "Card expiry month is required";

  }
  if ((!message) && (this.commonService.commonMainObj.selectedCardExpiryYear == null
    || this.commonService.commonMainObj.selectedCardExpiryYear==undefined
    || this.commonService.commonMainObj.selectedCardExpiryYear=="")){
      message = "Card expiry year is required";

  }
  if ((!message) && (this.commonService.commonMainObj.cardCvvNumber == null
    || this.commonService.commonMainObj.cardCvvNumber==undefined
    || this.commonService.commonMainObj.cardCvvNumber=="")){
      $('#cvv').addClass('border-red');
      this.cardCvv.nativeElement.focus();
      message = "Card cvv number is required";

}else{
  if (this.commonService.commonMainObj.cardCvvNumber) {
    let cn = new RegExp(/^[0-9]+$/)
    if(this.commonService.commonMainObj.cardCvvNumber && cn.test(this.commonService.commonMainObj.cardCvvNumber) == false){
      this.cardCvv.nativeElement.focus();
      message = "Card cvv must be in numbers";
      $("#cvv").focus();
    }
    //else if(this.commonService.commonMainObj.cardCvvNumber.length>4){
      //message = "Please enter a valid cvv";
      //$("#cvv").focus();
    //}
  }
}
  if ((!message) && (this.commonService.commonMainObj.cardType == null
    || this.commonService.commonMainObj.cardType==undefined
    || this.commonService.commonMainObj.cardType=="")){
      // message = "Please select a card type";
      this.cardNum.nativeElement.focus();
      message = "Please enter a valid credit card number.";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardNumber)
    && (this.commonService.commonMainObj.cardType=="1") &&
    (this.commonService.commonMainObj.cardNumber.toString()[0] != "6")
    ){
      message = "All Discover credit cards must start with digit 6";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardNumber)
    && (this.commonService.commonMainObj.cardType=="1") &&
    (this.commonService.commonMainObj.cardNumber.toString().length != 16)
    ){
      message = "Please enter a valid credit card number.<br> Note that Amex card needs 15 digits and Visa/ Mastercard/ Discover cards needs 16 digits.";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardNumber)
    && (this.commonService.commonMainObj.cardType=="2") &&
    (this.commonService.commonMainObj.cardNumber.toString()[0] != "3" )
    ){
      message = "All American Express credit cards must start with digit 3";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardNumber)
    && (this.commonService.commonMainObj.cardType=="2") &&
    (this.commonService.commonMainObj.cardNumber.toString().length != 15)
    ){
      message = "Please enter a valid credit card number.<br> Note that Amex card needs 15 digits and Visa/ Mastercard/ Discover cards needs 16 digits.";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardNumber)
    && (this.commonService.commonMainObj.cardType=="3") &&
    (this.commonService.commonMainObj.cardNumber.toString()[0] != "4" )
    ){
      message = "All Visa credit cards must start with digit 4";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardNumber)
    && (this.commonService.commonMainObj.cardType=="3") &&
    (this.commonService.commonMainObj.cardNumber.toString().length != 16)
    ){
      message = "Please enter a valid credit card number.<br> Note that Amex card needs 15 digits and Visa/ Mastercard/ Discover cards needs 16 digits.";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardNumber)
    && (this.commonService.commonMainObj.cardType=="4") &&
    (this.commonService.commonMainObj.cardNumber.toString()[0] != "5" )
    ){
      message = "All Mastercard credit cards must start with digit 5";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardNumber)
    && (this.commonService.commonMainObj.cardType=="4") &&
    (this.commonService.commonMainObj.cardNumber.toString().length != 16)
    ){
      message = "Please enter a valid credit card number.<br> Note that Amex card needs 15 digits and Visa/ Mastercard/ Discover cards needs 16 digits.";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardCvvNumber)
    && (this.commonService.commonMainObj.cardType=="2") &&
    (this.commonService.commonMainObj.cardCvvNumber.toString().length != 4)
    ){
      message = "American Express card should have 4 digit CVV number";

  }
  if ((!message) && (this.commonService.commonMainObj.cardType)
    && (this.commonService.commonMainObj.cardCvvNumber)
    && (this.commonService.commonMainObj.cardType=="1" || this.commonService.commonMainObj.cardType=="3" || this.commonService.commonMainObj.cardType=="4") &&
    (this.commonService.commonMainObj.cardCvvNumber.toString().length != 3)
    ){
      message = "Visa/ Mastercard/ Discover card should have 3 digit CVV number";

  }
  if ((!message) && (!dateRegEx1.test(this.commonService.commonMainObj.cardExpiryDate))){
      message = "Expiry date format is not correct";

  }else if(dateRegEx1.test(this.commonService.commonMainObj.cardExpiryDate)){
    if(this.commonService.commonMainObj.cardExpiryDate.split('/')[0].length == 1){
      this.commonService.commonMainObj.cardExpiryDate = "0" + this.commonService.commonMainObj.cardExpiryDate
    }
    if(new Date().getFullYear() > parseInt(this.commonService.commonMainObj.cardExpiryDate.split('/')[1])){
      message = "Please provide a valid expiry date";
    }else if (new Date().getFullYear() == parseInt(this.commonService.commonMainObj.cardExpiryDate.split('/')[1])){
      if(new Date().getMonth() + 1 > parseInt(this.commonService.commonMainObj.cardExpiryDate.split('/')[0])){
        message = "Please provide a valid expiry date";
      }
    }
  }
    if (message && !this.commonService.commonMainObj.isNotAuthChecked){
      Swal.fire({
        toast: false,
        //icon: 'warning',
        showConfirmButton: true,
        showCancelButton: false,
        showCloseButton: false,
        title:"Validation error",
        html:message,
        confirmButtonText: 'Ok'
      });
    // this.content.scrollToBottom();
  }else{
    // this.commonService.commonMainObj.getAddressBookData();
    let cardtype = this.commonService.commonMainObj.cardType;
    let name     = this.commonService.commonMainObj.cardHolderName;
    let cardnumber = this.commonService.commonMainObj.cardNumber;
    let expirydate  = this.commonService.commonMainObj.cardExpiryDate;
    let cvv      = this.commonService.commonMainObj.cardCvvNumber;
    // let defaultcard  = this.commonService.commonMainObj.defaultCreditCard;
    let card_details = {
      name       : name,
      cardtype   : this.commonService.commonMainObj.cardType,
      cardnumber : cardnumber,
      expirydate : expirydate,
      cvv        : cvv,
      id         : "1",
      typeid     : "1"
    };
    this.commonService.commonMainObj.selectedCreditCard = card_details;
    //alert("Route to next page");
    this.commonService.sessionPortalLoad();
    setTimeout(()=>{
      this.apiService.checkUserSessionApi().subscribe((data: any)=>{
        if(data.status == 1){
          this.commonService.commonMainObj.taxableBeforeOrderReview = this.commonService.commonMainObj.taxable
          if(this.commonService.commonMainObj.isNotAuthChecked){
            this.tax_radio_changed('Non-taxable');
          }
          this.router.navigateByUrl('/orderReview');  
        }
      },error =>{
        console.log('Error in checking user session', error);   
      })    
    },1000);
  }
  if (this.paymentForm.invalid) {
      return;
  }
}

promoKeyUp(eve:any){
  if(this.promoCodeText == ""){
    this.commonService.commonMainObj.promoCode = '';
    this.summaryPromoShow = false;
    this.commonService.commonMainObj.pcbPromoDiscount = '';
    this.commonService.commonMainObj.assemblyPromoDiscount = '';
    this.commonService.commonMainObj.componentPromoDiscount = '';
    this.commonService.commonMainObj.totalPromoDiscountAmount = "0.0";
    this.commonService.commonMainObj.pcbAssemblyPromo = false;
    $('#promo_code_apply').prop('disabled', false);
  }
}

promoReset(){
  this.promoCodeText = "";
  this.commonService.commonMainObj.promoCode = '';
  this.summaryPromoShow = false;
  this.commonService.commonMainObj.pcbPromoDiscount = '';
  this.commonService.commonMainObj.assemblyPromoDiscount = '';
  this.commonService.commonMainObj.componentPromoDiscount = '';
  this.commonService.commonMainObj.totalPromoDiscountAmount = "0.0";
  this.commonService.commonMainObj.pcbAssemblyPromo = false;
  $('#promo_code_apply').prop('disabled', false);
  $('#promo_code').prop('disabled',false);
}

promoCodeApply(){
  this.commonService.sessionPortalLoad();
  this.commonService.commonMainObj.totalPromoDiscountAmount = '';
  this.commonService.commonMainObj.promoCode = '';
  this.commonService.commonMainObj.pcbAssemblyPromo = false;
  if(this.promoCodeText == ""){
    this.commonService.alertCall('Alert!!','Please enter promo code');
    return false;
  }else{
    this.commonService.loadingShow();
    this.commonService.sessionPortalLoad();
    setTimeout(()=>{
      this.commonService.loadingHide();
      this.apiService.checkUserSessionApi().subscribe((data: any)=>{
        if(data.status == 1){
          this.promoCodeApplySessionChecked();
        }
      },error =>{
        console.log('Error in checking user session', error);   
      }) 
    },2000);
  }
}

promoCodeApplySessionChecked(){
  this.apiService.promoDeatils(this.promoCodeText).subscribe((data:any)=>{
    if(data.message =='This promoCode is invalid'){
      this.commonService.alertCall("Warning", "This promocode is invalid");
    }
    else{
      $('#promo_code_apply').prop('disabled', true);
      $('#promo_code').prop('disabled',true);
      this.summaryPromoShow = true;
      this.commonService.commonMainObj.promoCode = this.promoCodeText;
      if(data.length > 1){
        this.commonService.commonMainObj.pcbAssemblyPromo = true;
        //x = parseFloat(x.match(/[-+]?([0-9]*\.[0-9]+|[0-9]+)/));
        this.commonService.commonMainObj.pcbPromoDiscount = parseFloat(data[0].discountValue.match(/[-+]?([0-9]*\.[0-9]+|[0-9]+)/));
        this.commonService.commonMainObj.assemblyPromoDiscount = parseFloat(data[1].discountValue.match(/[-+]?([0-9]*\.[0-9]+|[0-9]+)/));
        this.commonService.commonMainObj.componentPromoDiscount = parseFloat(data[2].discountValue.match(/[-+]?([0-9]*\.[0-9]+|[0-9]+)/));
        // this.commonService.commonMainObj.totalPromoDiscountAmount = parseFloat(Number(data[0].discountValue).toFixed(2)) + parseFloat(Number(data[1].discountValue).toFixed(2)) + parseFloat(Number(data[2].discountValue).toFixed(2));
        this.commonService.commonMainObj.totalPromoDiscountAmount = parseFloat(Number(this.commonService.commonMainObj.pcbPromoDiscount).toFixed(2)) + parseFloat(Number(this.commonService.commonMainObj.assemblyPromoDiscount).toFixed(2)) + parseFloat(Number(this.commonService.commonMainObj.componentPromoDiscount).toFixed(2));
        $('#promo_discount_amount').append("PCB: $"+data[0].discountValue+", ASSEMBLY: $"+data[1].discountValue+", COMPONENTS: $"+data[2].discountValue)
      }else{
        this.commonService.commonMainObj.pcbAssemblyPromo = false;
        this.commonService.commonMainObj.pcbPromoDiscount = parseFloat(data[0].discountValue.match(/[-+]?([0-9]*\.[0-9]+|[0-9]+)/));
        this.commonService.commonMainObj.totalPromoDiscountAmount = parseFloat(this.commonService.commonMainObj.pcbPromoDiscount).toFixed(2);
          $('#promo_discount_amount').append("PCB: $"+data[0].discountValue);
      }
    }   
  }, error =>{
      console.log('Error in getting promocode deatils', error);
      $('#promo_code_apply').prop('disabled', false);
      $('#promo_code').prop('disabled',true);
      if(error.error.message =='This promoCode is invalid'){
        this.commonService.alertCall("Warning", "This promocode is invalid");
      }else{
        this.commonService.alertCall("Warning",error.error.message);
      }
      
  });
}

showCheckboxes() {
  let checkboxes = document.getElementById("checkboxes");
  if (!this.expanded) {
    $("#checkboxes").css('display' ,"block");
    this.expanded = true;
  } else {
    //checkboxes.style.display = "none";
    $("#checkboxes").css('display' ,"none");
    this.expanded = false;
  }
}

addressTypeSelect(event:any, type:any){
  if(type == 'shipping'){
    event.target['checked']
  }
  if(type == 'billing'){
    event.target['checked'];
  }
  if(type == 'designer'){
    event.target['checked'];
  }
}
notAuthSelection(eve:any){
  if(this.commonService.commonMainObj.isNotAuthChecked){
    this.commonService.commonMainObj.purchasingPersonDetails.paymentPending = false;
    $('#name_on_card').prop("disabled", true);
    $('#card_number').prop("disabled", true);
    $('#exp_month').prop("disabled", true);
    $('#exp_year').prop("disabled", true);
    $('#cvv').prop("disabled", true);
  }else{
    $('#name_on_card').prop("disabled", false);
    $('#card_number').prop("disabled", false);
    $('#exp_month').prop("disabled", false);
    $('#exp_year').prop("disabled", false);
    $('#cvv').prop("disabled", false);
  }
  if(this.commonService.commonMainObj.isNotAuthChecked && (this.commonService.commonMainObj.purchasingPersonDetails.firstName == '' || this.commonService.commonMainObj.purchasingPersonDetails.firstName == undefined) && (this.commonService.commonMainObj.purchasingPersonDetails.email == '' || this.commonService.commonMainObj.purchasingPersonDetails.email == undefined)){
    this.commonService.commonMainObj.purchasingPersonDetails.firstName = this.apiService.apiMainObj.selectedBillingAddress.firstName;
    this.commonService.commonMainObj.purchasingPersonDetails.lastName = this.apiService.apiMainObj.selectedBillingAddress.lastName;
    this.commonService.commonMainObj.purchasingPersonDetails.email = this.apiService.apiMainObj.selectedBillingAddress.email;
  }
  
}
authAgreedCheck(eve:any){
  if(this.commonService.commonMainObj.isNotAuthChecked && this.commonService.commonMainObj.purchasingPersonDetails.paymentPending){
    $('.agree-check').removeClass('red-brd');
  }
}

}
